



































import { shopServer } from "@/api/api.config";
import { Component, Vue } from "vue-property-decorator";
@Component
export default class center extends Vue {
  phone: string | number = 0;
  tel(phoneNumber: string | number) {
    window.location.href = "tel://" + phoneNumber;
  }
  clight = "";
  ids: any = "";
  city: any = "";
  lists: any = [];
  shopServerList() {
    shopServer({ ids: this.ids }).then((res) => {
      this.lists = res.data.enterpriseEntities;
      // console.log(this.lists);
    });
  }
  mounted() {
    // this.$nextTick(() => {
    //   this.clight = (this as any).$refs.centers.offsetHeight + 80 + "px";
    // });
    this.shopServerList();
  }

  addtocity() {
    this.$router.push({
      name: "Region",
    });
  }
  created() {
    this.city = this.$route.query.id;
    this.ids = this.$route.query.ids;
  }
}
